<template>
  <component :is="readOnly ? 'froalaView' : 'froala'"
             :class="{'border p-2 bg-gray-150':readOnly}"
             :config="froalaConfig"
             v-model="valueFromProp"></component>
</template>

<script>
  export default {
    name: 'gtc-froala',
    props: {
      readOnly: {
        type: Boolean,
        default: false
      },
      value: {
        default: null
      }
    },
    computed: {

    },
    created() {
      this.loadFroalaConfig();
      this.valueFromProp = _.trim(this.value);
      if (this.readOnly && this.valueFromProp === '') this.valueFromProp = 'N/A';
    },
    data: function () {
      return {
        froalaConfig: null,
        valueFromProp: null
      }
    },
    watch: {
      valueFromProp(newVal, oldVal) {
        let self = this;
        if (!this.readOnly && JSON.stringify(newVal) !== JSON.stringify(oldVal))
          self.$emit('input', newVal);
      },
      value(newVal, oldVal) {
        if (!newVal) {
          this.valueFromProp = '';
        }else if (JSON.stringify(newVal) !== JSON.stringify(oldVal))
          this.valueFromProp = newVal;
      }
    },
    methods: {
      loadFroalaConfig() {
        let self = this;
        self.froalaConfig = {
          key: 'SB3B17A7B8jC5D4H4G4J2A7A8C4A4A2A-9efpdeA6kfg==',
          attribution: false,
          // reference: https://froala.com/wysiwyg-editor/examples/toolbar-buttons-2/
          events: {
            'froalaEditor.video.error': function (error, editor) { // tslint:disable-line
              var $popup = editor.popups.get('video.insert');
              var $layer = $popup.find('.fr-video-progress-bar-layer');
              $layer.find('h3').text('Something went wrong. Before you try it again, please note that if you attach a video, the maximum size for the video is 30MB.');
            },
            'froalaEditor.image.uploaded': function (response) { // tslint:disable-line
              console.log(response)
            },
          },
          fileUpload: false,
          imageUpload: true,
          imageUploadURL: self.$root.baseUrl + '/ftie/upload_image/',
          imageUploadMethod: 'POST',
          enter: 'ENTER_BR',
          videoUpload: true,
          videoUploadURL: self.$root.baseUrl + '/ftie/upload_video/',
          imageUploadRemoteUrls: true,
          videoUploadMethod: 'POST',
          videoAllowedTypes: ['webm', 'jpg', 'ogg','mp4'],
          toolbarButtons: [
            'bold', 'italic', 'underline', 'strikeThrough', 'fontSize', 'color', '|',
            'formatOL', 'formatUL', '|', 'spellChecker', 'insertVideo'],
          pluginsEnabled: [
            'align', 'charCounter', 'codeBeautifier', 'codeView', 'colors', 'draggable',
            'embedly', 'entities', 'file', 'fontFamily', 'fontSize', 'fullscreen', 'image',
            'imageManager', 'inlineStyle', 'lineBreaker', 'link', 'lists', 'paragraphFormat',
            'paragraphStyle', 'quote', 'save', 'table', 'url', 'video', 'wordPaste', 'print'
          ],
          videoInsertButtons: ['videoBack', '|', 'videoUpload'],
          imageDefaultWidth: 0,
          videoMaxSize: 1024 * 1024 * 30
        }
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/framework/GtcFtieFroala.vue